// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"ToolTip_tooltip__3khbr","tooltipLabel":"ToolTip_tooltipLabel__HHK9r","icon":"ToolTip_icon__2bbb4","label":"ToolTip_label__3maLe"};